<template>
  <div class="crud-asistentes">
    <!-- ── HEADER ── -->
    <div class="page-header">
      <div>
        <h1 class="page-title-wrap">Asistentes de peleador</h1>
        <p class="page-sub">Evento activo · {{ asistentesFiltrados.length }} registros</p>
      </div>
      <div class="header-actions">
        <div class="busqueda-wrap">
          <i class="bi bi-search busqueda-icon"></i>
          <input
            v-model="busqueda"
            class="input-busqueda"
            placeholder="Buscar por nombre, apellido o correo..."
          />
          <button v-if="busqueda" class="busqueda-clear" @click="busqueda = ''">
            <i class="bi bi-x"></i>
          </button>
        </div>
        <button class="btn-secondary" @click="abrirFiltros = !abrirFiltros">
          <i class="bi bi-funnel"></i> Filtrar
        </button>
        <button
          class="btn-secondary"
          :disabled="generandoGafetesPdf"
          @click="descargarGafetesAsistentes"
        >
          <span v-if="generandoGafetesPdf"
            ><span class="spinner-border spinner-border-sm"></span
          ></span>
          <span v-else><i class="bi bi-qr-code-scan"></i> Generar gafetes (PDF)</span>
        </button>
        <button class="btn-primary" @click="abrirCrear">
          <i class="bi bi-plus-lg"></i> Agregar asistente
        </button>
      </div>
    </div>

    <!-- ── FILTROS ── -->
    <div v-if="abrirFiltros" class="filtros-bar">
      <div class="filtro-peleador-wrap">
        <PeleadorSelect
          v-model="filtroPeleador"
          :peleadores="peleadores"
          placeholder="Todos los peleadores"
          allow-clear
          @update:model-value="cargar"
        />
      </div>
      <select v-model="filtroActivo" class="filtro-select" @change="cargar">
        <option value="">Todos los estados</option>
        <option value="true">Activo</option>
        <option value="false">Inactivo</option>
      </select>
      <button class="btn-ghost" @click="limpiarFiltros">
        <i class="bi bi-x"></i> Limpiar
      </button>
    </div>

    <!-- ── TABLA ── -->
    <div class="tabla-wrapper">
      <div v-if="cargando" class="estado-centro">
        <span class="spinner-border spinner-border-sm text-warning me-2"></span>
        Cargando asistentes...
      </div>

      <div v-else-if="!asistentesFiltrados.length" class="estado-centro vacio">
        <i class="bi bi-person-badge" style="font-size: 2rem; opacity: 0.3"></i>
        <p>Sin asistentes registrados</p>
      </div>

      <table v-else class="tabla">
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Correo</th>
            <th>Peleador</th>
            <th>Activo</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="a in asistentesFiltrados" :key="a.id" class="tabla-fila">
            <td>
              <div class="asistente-cell">
                <div class="avatar-placeholder">{{ a.nombre?.charAt(0) }}</div>
                <p class="nombre">{{ a.nombre }} {{ a.apellido }}</p>
              </div>
            </td>
            <td>{{ a.correo }}</td>
            <td>{{ a.peleador_nombre || "—" }}</td>
            <td>
              <button
                class="badge-toggle"
                :class="a.activo ? 'badge-activo' : 'badge-inactivo'"
                :disabled="actualizandoId === a.id"
                @click="toggleActivo(a)"
              >
                {{ a.activo ? "Activo" : "Inactivo" }}
              </button>
            </td>
            <td>
              <button class="btn-icon" title="Editar" @click="abrirEditar(a)">
                <i class="bi bi-pencil-fill"></i>
              </button>
              <button
                class="btn-icon"
                title="Pase de identificación"
                :disabled="descargandoGafeteId === a.id"
                @click="descargarGafeteAsistente(a)"
              >
                <span v-if="descargandoGafeteId === a.id" class="spinner-border spinner-border-sm"></span>
                <i v-else class="bi bi-qr-code"></i>
              </button>
              <button
                class="btn-icon btn-danger-ghost"
                title="Eliminar"
                @click="confirmarEliminar(a)"
              >
                <i class="bi bi-trash3"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- ═══════════════════════════════════════════════════════════════════
         MODAL — CREAR / EDITAR ASISTENTE
    ════════════════════════════════════════════════════════════════════ -->
    <div v-if="modalAbierto" class="modal-overlay" @click.self="cerrarModal">
      <div class="modal-panel modal-mediano">
        <div class="modal-header">
          <div>
            <h2 class="modal-titulo">
              {{ modoEdicion ? "Editar asistente" : "Nuevo asistente" }}
            </h2>
            <p class="modal-sub">
              {{
                modoEdicion
                  ? `${asistenteForm.nombre} ${asistenteForm.apellido}`
                  : "Completa los datos del asistente."
              }}
            </p>
          </div>
          <button class="btn-icon" @click="cerrarModal">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>

        <div class="form-grid">
          <div class="form-group">
            <label>Nombre *</label>
            <input
              v-model="asistenteForm.nombre"
              class="input-form"
              placeholder="Ej. Juan"
            />
          </div>
          <div class="form-group">
            <label>Apellido *</label>
            <input
              v-model="asistenteForm.apellido"
              class="input-form"
              placeholder="Ej. Pérez"
            />
          </div>
          <div class="form-group col-span-2">
            <label>Correo *</label>
            <input
              v-model="asistenteForm.correo"
              type="email"
              class="input-form"
              placeholder="correo@ejemplo.com"
            />
          </div>
          <div class="form-group col-span-2">
            <label>Peleador *</label>
            <PeleadorSelect
              v-model="asistenteForm.peleador"
              :peleadores="peleadores"
              placeholder="Selecciona un peleador"
            />
          </div>

          <div class="form-section-label col-span-2">
            <i class="bi bi-toggles"></i> Estado
          </div>
          <div class="form-group col-span-2">
            <label class="check-label">
              <input type="checkbox" v-model="asistenteForm.activo" class="check-notif" />
              Activo
            </label>
          </div>
        </div>

        <div class="modal-footer">
          <button class="btn-secondary" @click="cerrarModal">Cancelar</button>
          <button class="btn-primary" :disabled="guardando" @click="guardar">
            <span v-if="guardando">
              <span class="spinner-border spinner-border-sm"></span>
            </span>
            <span v-else><i class="bi bi-floppy-fill"></i> Guardar</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import Swal from "sweetalert2";
import PeleadorSelect from "@/components/DashboardEvento/PeleadorSelect.vue";
import {
  getAsistentesDashboard,
  crearAsistenteDashboard,
  editarAsistenteDashboard,
  eliminarAsistenteDashboard,
  getPeleadoresDashboard,
  getGafeteAsistentePdf,
  getGafetesAsistentesPdf,
} from "@/utils/api_dashboard";

// ── Estado principal ─────────────────────────────────────────────────────────
const asistentes = ref([]);
const peleadores = ref([]);
const cargando = ref(false);
const busqueda = ref("");
const actualizandoId = ref(null);

const abrirFiltros = ref(false);
const filtroPeleador = ref("");
const filtroActivo = ref("");

const asistentesFiltrados = computed(() => {
  const q = busqueda.value.trim().toLowerCase();
  if (!q) return asistentes.value;
  return asistentes.value.filter(
    (a) =>
      (a.nombre ?? "").toLowerCase().includes(q) ||
      (a.apellido ?? "").toLowerCase().includes(q) ||
      (a.correo ?? "").toLowerCase().includes(q)
  );
});

function limpiarFiltros() {
  filtroPeleador.value = "";
  filtroActivo.value = "";
  cargar();
}

// ── Carga ────────────────────────────────────────────────────────────────────
async function cargar() {
  cargando.value = true;
  try {
    const filtros = {};
    if (filtroPeleador.value) filtros.peleador_id = filtroPeleador.value;
    if (filtroActivo.value) filtros.activo = filtroActivo.value;
    asistentes.value = await getAsistentesDashboard(filtros);
  } catch {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "No se pudo cargar la lista de asistentes.",
      background: "#0f1520",
      color: "#fff",
      confirmButtonColor: "#f3bc2c",
    });
  } finally {
    cargando.value = false;
  }
}

async function cargarPeleadores() {
  try {
    peleadores.value = await getPeleadoresDashboard();
  } catch {
    peleadores.value = [];
  }
}

onMounted(() => {
  cargar();
  cargarPeleadores();
});

// ── Toggle rápido (activo) ────────────────────────────────────────────────────
async function toggleActivo(a) {
  actualizandoId.value = a.id;
  const anterior = a.activo;
  a.activo = !a.activo;
  try {
    await editarAsistenteDashboard(a.id, { activo: a.activo });
  } catch {
    a.activo = anterior;
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "No se pudo actualizar.",
      background: "#0f1520",
      color: "#fff",
      confirmButtonColor: "#f3bc2c",
    });
  } finally {
    actualizandoId.value = null;
  }
}

// ── Gafetes (pase de identificación) ────────────────────────────────────────
const descargandoGafeteId = ref(null);
const generandoGafetesPdf = ref(false);

function descargarBlobComoArchivo(blob, filename) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

async function extraerErrorBlob(e) {
  const data = e.response?.data;
  if (data instanceof Blob) {
    try {
      return JSON.parse(await data.text())?.detail;
    } catch {
      return null;
    }
  }
  return data?.detail;
}

async function descargarGafeteAsistente(a) {
  descargandoGafeteId.value = a.id;
  try {
    const blob = await getGafeteAsistentePdf(a.id);
    descargarBlobComoArchivo(blob, `gafete_${a.nombre}_${a.apellido}.pdf`.replace(/\s+/g, "_"));
  } catch (e) {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: (await extraerErrorBlob(e)) || "No se pudo generar el gafete.",
      background: "#0f1520",
      color: "#fff",
      confirmButtonColor: "#f3bc2c",
    });
  } finally {
    descargandoGafeteId.value = null;
  }
}

async function descargarGafetesAsistentes() {
  generandoGafetesPdf.value = true;
  try {
    const blob = await getGafetesAsistentesPdf();
    descargarBlobComoArchivo(blob, "gafetes_asistentes.pdf");
  } catch (e) {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: (await extraerErrorBlob(e)) || "No se pudieron generar los gafetes.",
      background: "#0f1520",
      color: "#fff",
      confirmButtonColor: "#f3bc2c",
    });
  } finally {
    generandoGafetesPdf.value = false;
  }
}

// ── Modal crear / editar ──────────────────────────────────────────────────────
const modalAbierto = ref(false);
const modoEdicion = ref(false);
const guardando = ref(false);
const asistenteForm = ref(formVacio());

function formVacio() {
  return {
    id: null,
    nombre: "",
    apellido: "",
    correo: "",
    peleador: null,
    activo: true,
  };
}

function abrirCrear() {
  modoEdicion.value = false;
  asistenteForm.value = formVacio();
  modalAbierto.value = true;
}

function abrirEditar(a) {
  modoEdicion.value = true;
  asistenteForm.value = { ...a };
  modalAbierto.value = true;
}

function cerrarModal() {
  modalAbierto.value = false;
  asistenteForm.value = formVacio();
}

// ── Guardar (crear o editar) ──────────────────────────────────────────────────
async function guardar() {
  const a = asistenteForm.value;

  if (!a.nombre?.trim() || !a.apellido?.trim()) {
    Swal.fire({
      icon: "warning",
      title: "Faltan datos",
      text: "El nombre y apellido son obligatorios.",
      background: "#0f1520",
      color: "#fff",
      confirmButtonColor: "#f3bc2c",
    });
    return;
  }
  if (!a.correo?.trim()) {
    Swal.fire({
      icon: "warning",
      title: "Falta el correo",
      background: "#0f1520",
      color: "#fff",
      confirmButtonColor: "#f3bc2c",
    });
    return;
  }
  if (!a.peleador) {
    Swal.fire({
      icon: "warning",
      title: "Falta el peleador",
      text: "Selecciona a qué peleador asiste.",
      background: "#0f1520",
      color: "#fff",
      confirmButtonColor: "#f3bc2c",
    });
    return;
  }

  guardando.value = true;
  try {
    const payload = {
      nombre: a.nombre,
      apellido: a.apellido,
      correo: a.correo,
      peleador: a.peleador,
      activo: a.activo,
    };

    if (modoEdicion.value) {
      await editarAsistenteDashboard(a.id, payload);
    } else {
      await crearAsistenteDashboard(payload);
    }

    Swal.fire({
      icon: "success",
      title: "Guardado",
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 2000,
      background: "#0f1520",
      color: "#fff",
    });
    cerrarModal();
    cargar();
  } catch (e) {
    const msg = e.response?.data ? JSON.stringify(e.response.data) : "Error al guardar.";
    Swal.fire({
      icon: "error",
      title: "Error",
      text: msg,
      background: "#0f1520",
      color: "#fff",
      confirmButtonColor: "#f3bc2c",
    });
  } finally {
    guardando.value = false;
  }
}

// ── Eliminar ──────────────────────────────────────────────────────────────────
async function confirmarEliminar(a) {
  const resultado = await Swal.fire({
    icon: "warning",
    title: "¿Eliminar asistente?",
    text: `Se eliminará a "${a.nombre} ${a.apellido}" permanentemente.`,
    showCancelButton: true,
    confirmButtonText: "Eliminar",
    cancelButtonText: "Cancelar",
    confirmButtonColor: "#ef4444",
    cancelButtonColor: "rgba(255,255,255,0.2)",
    background: "#0f1520",
    color: "#fff",
  });
  if (!resultado.isConfirmed) return;

  try {
    await eliminarAsistenteDashboard(a.id);
    asistentes.value = asistentes.value.filter((x) => x.id !== a.id);
    Swal.fire({
      icon: "success",
      title: "Eliminado",
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 2000,
      background: "#0f1520",
      color: "#fff",
    });
  } catch {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "No se pudo eliminar.",
      background: "#0f1520",
      color: "#fff",
      confirmButtonColor: "#f3bc2c",
    });
  }
}
</script>

<style scoped>
.crud-asistentes {
  padding: 32px;
  font-family: "Inter", sans-serif;
  color: #fff;
  min-height: 100%;
}

/* ── Header ── */
.page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 16px;
}
.page-title-wrap {
  color: #f3bc2c;
  font-size: 22px;
  font-weight: 700;
  margin: 0;
}
.page-sub {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.45);
  margin: 4px 0 0;
}
.header-actions {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
}

/* ── Búsqueda ── */
.busqueda-wrap {
  position: relative;
  display: flex;
  align-items: center;
}
.busqueda-icon {
  position: absolute;
  left: 10px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.35);
  pointer-events: none;
}
.input-busqueda {
  background: #060d1a;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  color: #fff;
  padding: 7px 32px 7px 30px;
  font-size: 13px;
  width: 260px;
  outline: none;
  transition: border-color 0.15s, width 0.2s;
  font-family: "Inter", sans-serif;
}
.input-busqueda::placeholder {
  color: rgba(255, 255, 255, 0.25);
}
.input-busqueda:focus {
  border-color: rgba(243, 188, 44, 0.5);
  width: 300px;
}
.busqueda-clear {
  position: absolute;
  right: 8px;
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.35);
  cursor: pointer;
  padding: 0;
  font-size: 15px;
  line-height: 1;
  transition: color 0.15s;
}
.busqueda-clear:hover {
  color: #f87171;
}

/* ── Filtros ── */
.filtros-bar {
  display: flex;
  gap: 10px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}
.filtro-select {
  background: #060d1a;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  color: #fff;
  padding: 7px 12px;
  font-size: 13px;
  cursor: pointer;
}
.filtro-select option {
  background: #060d1a;
}
.filtro-peleador-wrap {
  width: 260px;
  max-width: 100%;
}
.btn-ghost {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  color: rgba(255, 255, 255, 0.5);
  border: none;
  border-radius: 8px;
  padding: 9px 12px;
  font-size: 13px;
  cursor: pointer;
  transition: color 0.15s;
}
.btn-ghost:hover {
  color: #fff;
}

/* ── Tabla ── */
.tabla-wrapper {
  background: #060d1a;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}
.estado-centro {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  gap: 10px;
  color: rgba(255, 255, 255, 0.45);
  font-size: 14px;
}
.tabla {
  width: 100%;
  min-width: 650px;
  border-collapse: collapse;
  font-size: 13px;
}
.tabla thead tr {
  background: rgba(255, 255, 255, 0.04);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.tabla th {
  padding: 12px 16px;
  text-align: left;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: rgba(255, 255, 255, 0.45);
  white-space: nowrap;
}
.tabla-fila {
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  transition: background 0.15s;
}
.tabla-fila:hover {
  background: rgba(255, 255, 255, 0.03);
}
.tabla td {
  padding: 12px 16px;
  vertical-align: middle;
}

.asistente-cell {
  display: flex;
  align-items: center;
  gap: 10px;
}
.avatar-placeholder {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: rgba(243, 188, 44, 0.2);
  color: #f3bc2c;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  flex-shrink: 0;
}
.nombre {
  font-weight: 600;
  margin: 0;
  font-size: 13px;
}

/* ── Badges toggle (activo) ── */
.badge-toggle {
  border-radius: 20px;
  padding: 3px 10px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  border: none;
  cursor: pointer;
  transition: opacity 0.15s;
}
.badge-toggle:hover:not(:disabled) {
  opacity: 0.8;
}
.badge-toggle:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.badge-activo {
  background: rgba(34, 197, 94, 0.15);
  color: #4ade80;
}
.badge-inactivo {
  background: rgba(255, 255, 255, 0.07);
  color: rgba(255, 255, 255, 0.5);
}

/* ── Botones ── */
.btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: #f3bc2c;
  color: #0f172a;
  border: none;
  border-radius: 8px;
  padding: 9px 16px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
  white-space: nowrap;
}
.btn-primary:hover:not(:disabled) {
  background: #e5ae24;
}
.btn-primary:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.btn-secondary {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: transparent;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  padding: 9px 16px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
}
.btn-secondary:hover {
  border-color: rgba(255, 255, 255, 0.4);
  background: rgba(255, 255, 255, 0.05);
}
.btn-icon {
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.4);
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.15s;
}
.btn-icon:hover {
  color: #f3bc2c;
  background: rgba(243, 188, 44, 0.1);
}
.btn-danger-ghost:hover {
  color: #f87171;
  background: rgba(239, 68, 68, 0.1);
}

/* ── Modal ── */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(4px);
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.modal-panel {
  background: #0f1520;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  width: 100%;
}
.modal-mediano {
  max-width: 560px;
}
.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 24px 24px 16px;
  flex-shrink: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.07);
}
.modal-titulo {
  font-size: 17px;
  font-weight: 700;
  margin: 0;
  color: #f3bc2c;
}
.modal-sub {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.4);
  margin: 4px 0 0;
}
.modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 24px;
  flex-shrink: 0;
  border-top: 1px solid rgba(255, 255, 255, 0.07);
  flex-wrap: wrap;
}

/* ── Form grid ── */
.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  padding: 20px 24px;
  overflow-y: auto;
  flex: 1;
}
.form-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.col-span-2 {
  grid-column: span 2;
}
label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: rgba(255, 255, 255, 0.45);
  display: flex;
  align-items: center;
  gap: 5px;
}
.check-label {
  flex-direction: row;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 500;
  text-transform: none;
  letter-spacing: normal;
  color: #fff;
  cursor: pointer;
}
.input-form {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: #fff;
  padding: 9px 12px;
  font-size: 13px;
  outline: none;
  transition: border-color 0.15s;
  width: 100%;
  font-family: "Inter", sans-serif;
  box-sizing: border-box;
}
.input-form:focus {
  border-color: rgba(243, 188, 44, 0.5);
}
.form-section-label {
  grid-column: span 2;
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #f3bc2c;
  padding: 6px 0 2px;
  border-bottom: 1px solid rgba(243, 188, 44, 0.15);
}

/* ── Responsive ── */
@media (max-width: 640px) {
  .crud-asistentes {
    padding: 16px;
  }
  .page-header {
    flex-direction: column;
    align-items: stretch;
  }
  .header-actions {
    flex-direction: column;
    align-items: stretch;
  }
  .busqueda-wrap {
    width: 100%;
  }
  .input-busqueda {
    width: 100%;
    box-sizing: border-box;
  }
  .header-actions .btn-primary {
    width: 100%;
    justify-content: center;
  }
  .filtros-bar {
    flex-direction: column;
    align-items: stretch;
  }
  .filtro-peleador-wrap {
    width: 100%;
  }
  .modal-overlay {
    padding: 12px;
  }
  .form-grid {
    grid-template-columns: 1fr;
  }
  .col-span-2 {
    grid-column: span 1;
  }
}
</style>
